module.exports = __webpack_public_path__ + "static/media/key.2042c5ec.svg";